/*
 * @Author: Hyman Choi
 * @Date: 2020-06-15 09:54:48
 * @LastEditTime: 2020-12-28 10:30:48
 * @LastEditors: Hyman Choi
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\utils\auth.js
 */
import Cookies from 'js-cookie'

const TokenKey = 'token'
const previewUrlKey = 'previewUrl'
const cloudUrlKey = 'cloudUrl'
const ossBucketKey = 'bucket'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setPreviewUrl2Cookie(previewUrl){
	return Cookies.set(previewUrlKey,previewUrl)
}

export function setCloudUrl2Cookie(cloudUrl){
	return Cookies.set(cloudUrlKey,cloudUrl)
}

export function setOssBucket2Cookie(ossBucket){
	return Cookies.set(ossBucketKey,ossBucket)
}
